import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

const DeleteVendorConfirm = (props) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth="false"
      sx={{ zIndex: 1000 }}
      open={true}
      onClose={props?.handleCloseDialog}
    >
      <DialogTitle
        sx={{ m: 0, p: 3, width: "600px", textAlign: "start", color: "green" }}
      >
        {"Delete Vendor"}
      </DialogTitle>
      <DialogContent >
      {`Are you sure to delete Vendor ${props?.selectedItem?.vchVendorName} ?`}
       </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props?.handleCloseDialog}>
          Cancel
        </Button>
        <Button onClick={props?.handleConfirmDelete}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteVendorConfirm;
